<script>
	import listBase from '@_system/components/base/list.vue'
	//import distributionIndex from './distribution/index.vue';
	import footerIndex from './footer/index.vue'
	export default {
		extends: listBase,
		name: 'crmcustomerIndex',
		render(h) {
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index list={this} ref="footer" row={this.currentrow} />
				</div>
			]
			return listBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				customerids:[],
				moduleName: 'crmcustomerwecom',
				windowName: '企微客户',
				exportData: [],
				currentrow: null,
				distributiontitle:'',
				distributionShow: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			// cellClick({row}) {
			// 	this.currentrow = row
			// 	this.$nextTick(()=>{
			// 		this.$refs.footer.inittab()
			// 	})
			// },
			// distribution(row) {
			// 	this.customerids = [row.id]
			// 	this.distributiontitle = '旺旺ID'+ row.buyerid
			// 	this.$refs.distribution.modalShow()
			// },
			// distributionSubmit(){
			// 	this.$refs.distribution.modalHide()
			// 	this.customreload()
			// },
			// beforeRender(data){
			// 	data.list.forEach((item)=>{
			// 		item.tag = JSON.parse(item.tag)
			// 	})
			// 	console.log(data)
			// },
			// pull(row){
			// 	this.loading = true
			// 	this.$api.crmcustomer.pull({id:row.id}).then(()=>{
			// 		this.loading = false
			// 		this.customerreload()
			// 	})
			// },
			// flowup(row) {
			// 	this.formModule = {
			// 		name: 'crmcustomerflowup',
			// 		id: 0,
			// 		controlltype: 1,
			// 		windowName: '回访单',
			// 		foreingKey: {},
			// 		extra: {
			// 			row:row
			// 		}
			// 	}
			// 	this.formwindowShow = true
			// }
		},
		components: {
			//distributionIndex,
			footerIndex
		}
	}
</script>
